import { FullStory, init } from '@fullstory/browser';
import environment from '@lib/environment';
import appManager from '../../app/appManager';
import AppModule from '../../app/lib/AppModule';
import { AuthEvents } from '@modules/AuthModule/types';
import { AuthUser } from '../AuthModule/lib/types';

export class FullStoryModule extends AppModule {
  private _sessionUrl: string | undefined;

  override preload(): void {
    this.app.events.on('app.started', () => {
      if (environment.FULLSTORY_ORG_ID) {
        init(
          {
            devMode: environment.MODE !== 'production',
            orgId: environment.FULLSTORY_ORG_ID,
          },
          ({ sessionUrl }) => {
            this._sessionUrl = sessionUrl;
          },
        );
        FullStory('setProperties', {
          type: 'page',
          properties: {
            appVersion: environment.APP_VERSION,
          },
        });
        this.app.logger.info('initialized');
      }
    });

    this.app.events.on(AuthEvents.SIGNIN, (user: AuthUser) => {
      if (environment.FULLSTORY_ORG_ID) {
        FullStory('setIdentity', {
          uid: user.id,
          properties: {
            displayName: user.name,
            email: user.email,
            service: user.contactCenterId,
            accountId: user.accountId,
            contactCenterId: user.contactCenterId,
            orgId: user.org.id,
            orgName: user.org.name,
            appVersion: environment.APP_VERSION,
          },
        });

        this.app.logger.info('user identified: ', user.id);
      }
    });

    // write logs to FS console (only info because
    // FS has a limit of 1024 messages)
    this.app.logger.on('info', (key, message, args) => {
      if (environment.FULLSTORY_ORG_ID && this.initialized) {
        const msg = `info(${key}): ${message} ${JSON.stringify(args)}`;
        FullStory('log', { level: 'log', msg });
      }
    });

    // write errors to FS console (these error events catch more than just
    // what is manually logged)
    this.app.events.on('diagnostics.error', (error: any) => {
      if (environment.FULLSTORY_ORG_ID && this.initialized) {
        const { message, key, args } = error;
        const msg = `error(${key}): ${message} ${JSON.stringify(args)}`;
        FullStory('log', { level: 'error', msg });
      }
    });
  }

  public get sessionUrl(): string | undefined {
    return this._sessionUrl;
  }

  private get initialized(): boolean {
    return !!this._sessionUrl;
  }

  public trackEvent(name: string, properties: Record<string, any>): void {
    if (environment.FULLSTORY_ORG_ID && this.initialized) {
      FullStory('trackEvent', { name, properties });
    }
  }
}

export default new FullStoryModule(
  appManager.events,
  appManager.logger('FullStory'),
);
